import { projectModelSelector } from 'src/selectors/projectModel';
import { ReduxState } from 'src/store/types';

/**
 * Selector to determine if a project model can be refreshed.
 * A model can be refreshed if:
 * 1. It exists
 * 2. It was imported from a database (has databaseId)
 * 3. It has an original model name stored (for looking up in database)
 */
export const projectModelShouldShowRefreshSelector =
  (projectId: string | undefined, modelId: string | undefined) =>
  (state: ReduxState): boolean => {
    if (!projectId || !modelId) {
      return false;
    }

    const projectModel = projectModelSelector(projectId, modelId)(state);

    if (!projectModel) {
      return false;
    }

    // Model must have been imported from a database
    if (!projectModel.databaseId) {
      return false;
    }

    // Model must have original name stored (for database lookup)
    if (!projectModel.importedModelName) {
      return false;
    }

    return true;
  };
